/* ===========================================================================
   <sale-countdown> — evergreen / fixed-date product countdown
   ---------------------------------------------------------------------------
   Powers the "Sale Ends In:" product block (snippets/product-sale-countdown.liquid).

   Modes (data-mode):
     - "evergreen": counts down to the visitor's next local midnight and
       auto-restarts at 00:00, so the urgency timer is always live. (This is
       the behaviour ported from thecottonliving theme.)
     - "date": counts down to a fixed end date (data-date, mm-dd-yyyy). When it
       reaches zero the timer freezes at 00 and the block hides if
       data-hide-on-end="true".

   JS only writes the digits ([data-unit]); all labels/markup come from Liquid,
   so the element upgrades cleanly on initial render and on theme-editor reloads.
   =========================================================================== */
(function () {
  if (typeof customElements === 'undefined') return;
  if (customElements.get('sale-countdown')) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  function nextMidnight() {
    var t = new Date();
    t.setHours(24, 0, 0, 0);
    return t.getTime();
  }

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.daysEl    = this.querySelector('[data-unit="days"]');
      this.hoursEl   = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.daysItem  = this.querySelector('[data-days-item]');

      this.mode = this.dataset.mode || 'evergreen';
      this.hideOnEnd = this.dataset.hideOnEnd === 'true';

      this.fixedTarget = null;
      if (this.mode === 'date' && this.dataset.date) {
        var parsed = new Date(Date.parse(this.dataset.date)).getTime();
        if (isNaN(parsed)) parsed = new Date(this.dataset.date.replace(/-/g, '/')).getTime();
        if (!isNaN(parsed)) this.fixedTarget = parsed;
      }

      this.target = this.getTarget();
      this.tick();
      this.intervalId = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    getTarget() {
      if (this.mode === 'date' && this.fixedTarget) return this.fixedTarget;
      return nextMidnight();
    }

    tick() {
      var now = Date.now();
      var diff = this.target - now;

      if (diff <= 0) {
        if (this.mode === 'date') {
          // Fixed sale ended — freeze at zero, optionally hide.
          if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null; }
          if (this.hideOnEnd) { this.closest('[data-sale-countdown-root]').hidden = true; }
          diff = 0;
        } else {
          // Evergreen — roll over to the next midnight.
          this.target = nextMidnight();
          diff = this.target - now;
        }
      }

      var total   = Math.floor(diff / 1000);
      var days    = Math.floor(total / 86400);
      var hours   = Math.floor((total % 86400) / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;

      if (this.daysItem) {
        if (days > 0) {
          this.daysItem.hidden = false;
          if (this.daysEl) this.daysEl.textContent = pad(days);
        } else {
          this.daysItem.hidden = true;
        }
      }
      if (this.hoursEl)   this.hoursEl.textContent   = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
})();
